import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, Cell, LabelList } from "recharts";
import { formatCurrency } from "../lib/api";

/**
 * Side-by-side bar chart: 2025 vs 2026 across chosen rows.
 * rows = [{ label, v2025, v2026, format? }]
 */
export const ComparisonChart = ({ rows, title = "Visual Comparison", testid = "comparison-chart" }) => {
  const data = rows.map((r) => ({
    name: r.label,
    "2025": Number(r.v2025) || 0,
    "2026": Number(r.v2026) || 0,
  }));

  return (
    <div
      className="bg-card border-2 border-foreground p-6 md:p-8"
      data-testid={testid}
    >
      <div className="flex items-center justify-between mb-6 pb-4 border-b border-foreground/20">
        <div>
          <span className="font-mono text-[10px] uppercase tracking-[0.3em] text-muted-foreground block">
            § Visual
          </span>
          <h3 className="font-heading text-xl font-semibold mt-1">{title}</h3>
        </div>
        <div className="flex gap-4 font-mono text-[10px] uppercase tracking-widest">
          <span className="flex items-center gap-2">
            <span className="w-3 h-3 bg-foreground inline-block" />
            2025
          </span>
          <span className="flex items-center gap-2">
            <span className="w-3 h-3 bg-primary inline-block" />
            2026
          </span>
        </div>
      </div>

      <div className="w-full h-[320px]">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={data} margin={{ top: 24, right: 16, left: 0, bottom: 0 }}>
            <XAxis
              dataKey="name"
              tickLine={false}
              axisLine={{ stroke: "hsl(220 20% 10%)" }}
              tick={{ fontFamily: "IBM Plex Mono, monospace", fontSize: 10, fill: "hsl(220 20% 10%)", textTransform: "uppercase" }}
              interval={0}
              height={50}
            />
            <YAxis
              tickLine={false}
              axisLine={false}
              tick={{ fontFamily: "IBM Plex Mono, monospace", fontSize: 10, fill: "hsl(220 10% 40%)" }}
              tickFormatter={(v) =>
                Math.abs(v) >= 1000 ? `$${(v / 1000).toFixed(0)}k` : `$${v}`
              }
            />
            <Tooltip
              cursor={{ fill: "hsl(40 15% 90%)" }}
              contentStyle={{
                backgroundColor: "hsl(220 20% 10%)",
                border: "none",
                borderRadius: 0,
                fontFamily: "IBM Plex Mono, monospace",
                fontSize: 11,
                color: "white",
              }}
              itemStyle={{ color: "white" }}
              labelStyle={{ color: "hsl(40 20% 97%)", fontFamily: "Playfair Display, serif", fontWeight: 600 }}
              formatter={(v) => formatCurrency(v)}
            />
            <Bar dataKey="2025" fill="hsl(220 20% 10%)" maxBarSize={60}>
              <LabelList
                dataKey="2025"
                position="top"
                formatter={(v) => (v >= 1000 ? `$${(v / 1000).toFixed(1)}k` : `$${v}`)}
                style={{ fontFamily: "IBM Plex Mono, monospace", fontSize: 10, fill: "hsl(220 20% 10%)" }}
              />
            </Bar>
            <Bar dataKey="2026" fill="hsl(150 80% 20%)" maxBarSize={60}>
              <LabelList
                dataKey="2026"
                position="top"
                formatter={(v) => (v >= 1000 ? `$${(v / 1000).toFixed(1)}k` : `$${v}`)}
                style={{ fontFamily: "IBM Plex Mono, monospace", fontSize: 10, fill: "hsl(150 80% 20%)" }}
              />
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};
